<template>
 <v-dialog
        v-model="showDialog"
        max-width="1000"
        persistent
        class="edit-masterdata flex-none"
    >
        <template #activator="{ on }">
            <div v-on="on" class="edit-masterdata-activator" style="width: 100%">
                <v-tooltip bottom v-if="alternativeBtn">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-on="on"
                            @click="show()"
                            v-bind="$attrs"
                            class="drei_60-btn mb-2"
                            block
                        >
                            Stammdaten bearbeiten
                        </v-btn>
                    </template>
                    <div class="max-width-btn">
                        Bearbeiten von Anrede, Titel, Vorname, Nachname, Straße, Hausnummer, Postleitzahl, Ort und Geburtsdatum des Benutzers.
                    </div>
                </v-tooltip>
                <v-tooltip left v-if="!alternativeBtn">
                    <template #activator="{ on }">
                        <v-btn
                            v-on="on"
                            @click="show()"
                            v-bind="$attrs"
                            text
                            icon
                            class="drei_60-black-text"
                        >
                            <v-icon v-bind="$attrs">mdi-account-edit</v-icon>
                        </v-btn>
                    </template>
                    <span>Stammdaten bearbeiten</span>
                </v-tooltip>
            </div>
        </template>
        <v-card>
            <v-card-title
                class="headline"
                primary-title
            >
                Stammdaten bearbeiten
            </v-card-title>
            <v-card-text v-if="loading">
                <v-container d-flex align-center justify-center>
                    <v-progress-circular
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
                </v-container>
            </v-card-text>
            <v-card-text v-if="!loading">
                <div class="customer-edit-masterdata">
                    <v-layout wrap mt-4 mb-4>
                        <span>
                            Ändern der Stammdaten des Benutzers in allen Systemen.
                        </span>
                    </v-layout>
                        <v-layout wrap mb-2>
                            <v-flex md12>
                                <v-stepper vertical v-model="this.wizardStep" class="customer-edit-wizard">
                                    <v-stepper-step
                                        step="1"
                                        :complete="this.wizardStep > 1"
                                        edit-icon="$complete"
                                        color="success">
                                        Stammdaten ändern
                                    </v-stepper-step>
                                    <v-stepper-content step="1">
                                        <v-form :value="valid" ref="customerEditForm" v-on:submit.prevent>
                                            <v-layout wrap mb-4>
                                                <v-flex md6 pr-1>
                                                    <v-select
                                                        label="Anrede"
                                                        :rules="rules.anrede"
                                                        :value="gender"
                                                        @input="setGender"
                                                        :disabled="inAction || isChecking"
                                                        :items="anreden"
                                                    ></v-select>
                                                </v-flex>
                                                <v-flex md6 pl-1>
                                                    <v-text-field
                                                        label="Titel"
                                                        :rules="rules.titel"
                                                        :value="title"
                                                        @input="setTitle"
                                                        :disabled="inAction || isChecking"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout wrap mb-4>
                                                <v-flex md6 pr-1>
                                                    <v-text-field
                                                        label="Vorname"
                                                        :rules="rules.vorname"
                                                        :value="firstname"
                                                        @input="setFirstname"
                                                        :disabled="inAction || isChecking"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex md6 pl-1>
                                                    <v-text-field
                                                        label="Nachname"
                                                        :rules="rules.nachname"
                                                        :value="lastname"
                                                        @input="setLastname"
                                                        :disabled="inAction || isChecking"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout wrap mb-4>
                                                <v-flex md6 pr-1>
                                                    <v-text-field
                                                        label="Straße"
                                                        :rules="rules.strasse"
                                                        :value="street"
                                                        @input="setStreet"
                                                        :disabled="inAction || isChecking"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex md6 pl-1>
                                                    <v-text-field
                                                        label="Hausnummer"
                                                        :rules="rules.hausnummer"
                                                        :value="streetNumber"
                                                        @input="setStreetnumber"
                                                        :disabled="inAction || isChecking"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout wrap mb-4>
                                                <v-flex md6 pr-1>
                                                    <v-text-field
                                                        label="Postleitzahl"
                                                        :rules="rules.plz"
                                                        :value="zipCode"
                                                        @input="setZipCode"
                                                        :disabled="inAction || isChecking"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex md6 pl-1>
                                                    <v-text-field
                                                        label="Ort"
                                                        :rules="rules.ort"
                                                        :value="city"
                                                        @input="setCity"
                                                        :disabled="inAction || isChecking"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout wrap mb-4>
                                                <v-flex md6 pr-1>
                                                    <v-menu
                                                        ref="dateMenu"
                                                        v-model="dateMenu"
                                                        :close-on-content-click="false"
                                                        transition="scale-transition"
                                                        offset-y
                                                        max-width="290px"
                                                        min-width="auto"
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                :value="birthdate"
                                                                :rules="rules.geburtsdatum"
                                                                label="Geburtsdatum"
                                                                hint=""
                                                                persistent-hint
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                @change="setBirthdate"
                                                                @input="dateMenu = false"
                                                                :disabled="inAction || isChecking"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            :value="birthdate !== '' ? formattedBirthdate : dateNowFormatted"
                                                            no-title
                                                            @input="setBirthdateFormatted"
                                                            @change="dateMenu = false"
                                                            locale="de"
                                                        ></v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                                <v-flex md6 pr-1 align-self-end>
                                                    <div class="edit-stepper-content-actions">
                                                        <v-btn
                                                            color="success"
                                                            outlined
                                                            :loading="isChecking"
                                                            :disabled="isChecking || valid"
                                                            @click="check"
                                                        >
                                                            Weiter
                                                        </v-btn>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                        </v-form>
                                    </v-stepper-content>
                                    <v-stepper-step step="2"
                                                    :complete="this.wizardStep > 2"
                                                    edit-icon="$complete"
                                                    color="success">
                                        Systeme auswählen
                                    </v-stepper-step>
                                    <v-stepper-content step="2">
                                        <v-layout wrap mb-4>
                                            <v-flex md12 pr-1>
                                                <KeineDaten v-if="loading"></KeineDaten>
                                                <v-simple-table v-if="!loading">
                                                    <template v-slot:default>
                                                        <thead>
                                                        <th>Auswahl</th>
                                                        <th>System</th>
                                                        <th>Scope</th>
                                                        <th>ID</th>
                                                        <th>Anrede</th>
                                                        <th>Vorname</th>
                                                        <th>Nachname</th>
                                                        <th>Adresse</th>
                                                        <th>Geburtsdatum</th>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, index) in systems" :key="index">
                                                                <td>
                                                                    <v-simple-checkbox
                                                                        v-model="item.selected"
                                                                        :ripple="false"
                                                                    >
                                                                    </v-simple-checkbox>
                                                                </td>
                                                                <td>{{ item.system }}</td>
                                                                <td>{{ item.scope }}</td>
                                                                <td>{{ item.id }}</td>
                                                                <td>{{ item.gender }}</td>
                                                                <td>{{ item.firstName }}</td>
                                                                <td>{{ item.lastName }}</td>
                                                                <td>{{
                                                                        (item.street ? item.street + ' ' : '') +
                                                                       (item.streetNumber ? item.streetNumber + ', '  : '') +
                                                                       (item.zipCode ? item.zipCode + ' ' : '') +
                                                                       (item.city ? item.city : '')
                                                                    }}</td>
                                                                <td>{{ item.birthdate }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout wrap mb-4>
                                            <v-flex md12 pr-1 align-self-end>
                                                <div class="edit-stepper-content-actions">
                                                    <v-btn
                                                        class="mr-2"
                                                        color="warning"
                                                        outlined
                                                        @click="setWizardStep(1)"
                                                    >
                                                        Zurück
                                                    </v-btn>
                                                    <v-btn
                                                        color="success"
                                                        outlined
                                                        v-if="checkIfNeedStore"
                                                        :loading="isChecking"
                                                        :disabled="isChecking || valid"
                                                        @click="setWizardStep(3)"
                                                    >
                                                        Weiter
                                                    </v-btn>
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                    </v-stepper-content>
                                    <v-stepper-step v-if="checkIfNeedStore && wizardStep > 1" step="3" color="success">
                                        Evalanche Store auswählen
                                    </v-stepper-step>
                                    <v-stepper-content v-if="checkIfNeedStore && wizardStep > 1" step="3">
                                        <v-layout wrap mb-4>
                                            <v-flex md12 p-2>
                                                <div class="ml-2">
                                                    <EvalancheStoreSelect
                                                        class="mb-2 mt-2"
                                                        :store="storeId"
                                                        @change="setStoreId"
                                                    />
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout wrap mb-4>
                                            <v-flex md12 pr-1 align-self-end>
                                                <div class="edit-stepper-content-actions">
                                                    <v-btn
                                                        color="warning"
                                                        outlined
                                                        @click="setWizardStep(2)"
                                                    >
                                                        Zurück
                                                    </v-btn>
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                    </v-stepper-content>
                                </v-stepper>
                            </v-flex>
                        </v-layout>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="warning"
                    outlined
                    @click="abort"
                    class="mr-2"
                    :disabled="loading || inAction || isChecking"
                >Abbrechen</v-btn>
                <ConfirmationDialog
                        :alternativeBtn="true"
                        :loading="loading || inAction || isChecking"
                        :disabled="loading || valid || inAction || isChecking || (checkIfNeedStore ? wizardStep < 3 : wizardStep < 2) || (checkIfNeedStore && this.storeId === '')"
                        @submit="submit"
                        pl-0 pr-0
                        btnText="Stammdaten speichern"
                        btnClass="success"
                        submitText="Stammdaten speichern"
                        abortText="Abbrechen"
                        dialogTitle="Stammdaten speichern"
                        dialogText="Möchten Sie die Stammdaten wirklich in allen Systemen ändern?"

                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {
    mapActions,
    mapMutations,
    mapState,
} from 'vuex';
import moment from 'moment';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import KeineDaten from '@/components/customer/KeineDaten.vue';
import EvalancheStoreSelect from '@/components/EvalancheStoreSelect.vue';

const EVALANCHE = 'evalanche';

export default {
    name: 'CustomerEdit',
    props: ['ssoId', 'alternativeBtn', 'isLoading'],
    components: {
        EvalancheStoreSelect,
        ConfirmationDialog,
        KeineDaten,
    },
    data() {
        return {
            showDialog: false,
            anreden: [
                { text: 'Herr', value: 'male' },
                { text: 'Frau', value: 'female' },
                { text: 'Firma', value: 'company' },
            ],
            dateMenu: false,
            rules: {
                anrede: [
                    (v => this.anreden.find(e => e.value === v)) ? true : false || 'Ungültige Anrede',
                ],
                title: [
                    v => v.length <= 10 || 'Titel darf maximal 10 Zeichen lang sein.',
                ],
                vorname: [
                    v => !!v || 'Vorname muss gesetzt sein.',
                    v => v.length <= 35 || 'Vorname darf maximal 35 Zeichen lang sein.',
                ],
                nachname: [
                    v => !!v || 'Nachname muss gesetzt sein.',
                    v => v.length <= 35 || 'Nachname darf maximal 35 Zeichen lang sein.',
                ],
                strasse: [
                    v => v.length <= 35 || 'Straße darf maximal 35 Zeichen lang sein.',
                ],
                hausnummer: [
                    v => v.length <= 10 || 'Hausnummer darf maximal 10 Zeichen lang sein.',
                ],
                plz: [
                    v => v.length <= 5 || 'Postleitzahl darf maximal 5 Zeichen lang sein.',
                ],
                ort: [
                    v => v.length <= 35 || 'Ort darf maximal 35 Zeichen lang sein.',
                ],
                geburtsdatum: [
                    v => !!v || 'Geburtsdatum muss gesetzt sein.',
                    v => moment(v, 'L', 'de').isValid() || 'Geburtsdatum muss ein gültiges Datum im Format TT.MM.JJJJ sein.',
                ],
            },
        };
    },
    computed: {
        ...mapState('customerEdit', [
            'loading',
            'isChecking',
            'gender',
            'title',
            'firstname',
            'lastname',
            'street',
            'streetNumber',
            'zipCode',
            'city',
            'valid',
            'inAction',
            'birthdate',
            'systems',
            'wizardStep',
            'storeId',
        ]),
        formattedBirthdate() {
            const momentDate = moment(this.birthdate, 'L', 'de');
            const newDate = momentDate.locale('en').format('YYYY-MM-DD');
            return newDate;
        },
        dateNowFormatted() {
            return moment().format('YYYY-MM-DD');
        },
        checkIfNeedStore() {
            const evalanche = this.systems.filter(s => s.system.toLowerCase() === EVALANCHE)[0];
            if (evalanche && evalanche.id && evalanche.selected) return false;
            return true;
        },
    },
    methods: {
        ...mapActions('customerEdit', ['updateCustomer', 'resetState', 'initState', 'checkCustomer']),
        show() {
            this.initState(this.ssoId);
        },
        check() {
            const isValid = this.$refs.customerEditForm.validate();
            if (isValid) {
                this.checkCustomer(this.ssoId);
            }
        },
        submit() {
            this.updateCustomer(this.ssoId)
                .then(() => {
                    this.$emit('close');
                    this.showDialog = false;
                })
                .catch(() => null);
        },
        setBirthdateFormatted(date) {
            const momentDate = moment(date);
            const newDate = momentDate.locale('de').format('L');
            this.setBirthdate(newDate);
        },
        abort() {
            this.resetState();
            this.$emit('close');
            this.snackInfo('Bearbeiten der Stammdaten wurde abgebrochen.');
            this.showDialog = false;
        },
        ...mapMutations('customerEdit', [
            'setSsoId',
            'setGender',
            'setTitle',
            'setFirstname',
            'setLastname',
            'setStreet',
            'setStreetnumber',
            'setZipCode',
            'setCity',
            'setLoading',
            'setValid',
            'setInAction',
            'setBirthdate',
            'setStoreId',
            'setWizardStep',
        ]),
        ...mapMutations('snackbar', {
            snackError: 'error',
            snackSuccess: 'success',
            snackInfo: 'info',
        }),
    },
};
</script>

<style lang="scss">
.customer-edit-wizard-step-label {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex-direction: row;
}
.v-stepper__label {
    width: 100% !important;
}
.customer-edit-wizard {
    box-shadow: none;
    -webkit-box-shadow: none;
    margin-top: 10px;
    .v-stepper__content {
        border-left: 1px solid #ebebeb;
        border-right: 1px solid #ebebeb;
        margin: -8px 0px 0px 0px !important;
        padding: 0px 23px 0px 23px;
        &:last-child {
            border-bottom: 1px solid #ebebeb;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
        }
    }
    .v-stepper__step {
        border: 1px solid #ebebeb;
        padding: 10px 16px 10px 16px !important;
        background: #ebebeb;
    }
    &.no-steps {
        .v-stepper__step {
            display: none;
        }

        .v-stepper__content {
            border-left: 0;
            border-right: 0;
            border-bottom: 0;
        }
    }
}
.edit-stepper-content {
    padding: 16px 0 16px 0;
}
.edit-stepper-content-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}
</style>
